"use client";

type DataLayerEvent = {
  event: string;
  [key: string]: unknown;
};

declare global {
  interface Window {
    dataLayer?: DataLayerEvent[];
  }
}

export function pushToDataLayer(event: DataLayerEvent) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

export function trackSignUp(fullName: string, email: string) {
  pushToDataLayer({
    event: "sign_up",
    user_data: {
      full_name: fullName,
      email,
    },
  });
}

export function trackSubscribe(params: {
  fullName: string | null | undefined;
  email: string | null | undefined;
  planCode?: string | null | undefined;
  priceId?: string | null | undefined;
  quantity?: number | null | undefined;
  amountTotal?: number | null | undefined;
  currency?: string | null | undefined;
}) {
  const {
    fullName,
    email,
    planCode,
    priceId,
    quantity,
    amountTotal,
    currency,
  } = params;

  const payload: DataLayerEvent = {
    event: "subscribe",
    user_data: {
      full_name: fullName ?? "",
      email: email ?? "",
    },
    planCode: planCode ?? "",
    quantity:
      typeof quantity === "number" && Number.isFinite(quantity) ? quantity : 0,
    amountTotal:
      typeof amountTotal === "number" && Number.isFinite(amountTotal)
        ? amountTotal
        : 0,
    currency: currency ?? "",
  };

  if (priceId) payload.priceId = priceId;

  pushToDataLayer(payload);
}
